import { createApp } from 'vue'
import { setupProviders } from '@/app/providers'
import App from './App.vue'
import './index.css'

const app = createApp(App)

// Setup global providers (Router, Pinia, i18n, etc.)
setupProviders(app)

export { app }
